import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Container = styled.div``;

export const Header = styled.div`
  margin: 30px;
  margin-left: 80px;
  display: flex;
  align-items: center;
`;

export const ErrorContainer = styled.div`
  width: 60%;
  min-width: 600px;
  margin: 10px auto 30px auto;

  background: orange;
  color: #fff;

  border-radius: 8px;
  padding: 30px;

  p {
    text-align: center;
    font-size: 22px;
  }
`;

export const Card = styled.div`
  width: 80%;
  padding: 30px;
  background: ${(props) => props.theme.colors.white};
  border-radius: 8px;
  margin-top: 10px;
  /* justify-content: center;
  display: flex;
  flex-direction: column; */
`;

export const AreaTable = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  min-width: 400px;
  width: 100%;
  height: calc(100% - 66px);
  margin-top: 10px;

  margin-bottom: 45px;

  /* @media (max-width: 1680px) {
    max-width: 1200px;
  }

  @media (max-width: 1440px) {
    max-width: 1000px;
  }

  @media (max-width: 1366px) {
    max-width: 900px;
  }

  @media (max-width: 1024px) {
    max-width: 700px;
  } */
`;

export const TotalsArea = styled.div`
  width: 45%;
  background: #fff;
  border-radius: 8px;
  margin-left: 5px;
  display: flex;
  justify-content: space-around;
`;

export const TotalsAreaInner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;

  p {
    text-align: center;
  }
`;

export const CategoriesTableData = styled.table`
  border-collapse: separate;
  border-spacing: 10px 26px;
  background: ${(props) => props.theme.colors.white};
  width: 80%;
  border-radius: 8px;
  padding: 0 30px;
  display: block;
  overflow-x: auto;
  white-space: nowrap;

  thead {
    border-bottom: 30px solid transparent;
    text-align: center;
  }
  tbody {
    td {
      border-bottom: 1px solid #eee;
      text-align: center;
      border-bottom: none;
    }

    tr:last-child {
      td {
        border-bottom: none;
        text-align: center;
      }
    }
  }
`;

export const CategoriesTable = styled.table`
  border-collapse: separate;
  border-spacing: 10px 16px;
  background: ${(props) => props.theme.colors.white};
  width: 80%;
  border-radius: 8px;
  padding: 0 30px;
  display: block;
  overflow-x: auto;
  white-space: nowrap;

  thead {
    border-bottom: 30px solid transparent;
    text-align: center;
  }
  tbody {
    td {
      border-bottom: 1px solid #eee;
      text-align: center;
      border-bottom: none;
    }

    tr:last-child {
      td {
        border-bottom: none;
        text-align: center;
      }
    }
  }
`;

export const StyledLink = styled(Link)`
  &:hover {
    text-decoration: none;
  }
`;

export const Delete = styled.button`
  border: none;
  background: none;

  &:active {
    border: none;
  }

  svg {
    color: ${(props) => props.theme.colors.secondary};
  }
`;

export const Actions = styled.div``;

export const BoxTotal = styled.div`
  width: 90%;
  clear: both;
  margin: 0 auto;
  justify-content: center;
  text-align: center;
  padding-bottom: 20px;
  border-bottom: 1px solid #dee2e6;
  display: flex;
`;

export const BoxOthers = styled.div`
  margin: 0 auto;
  padding: 20px;
  display: flex;
  justify-content: space-around;
  width: 90%;
  flex-wrap: wrap;
`;

export const DateSelectorDiv = styled.div`
  width: 90%;
  clear: both;
  margin: 0 auto;
  text-align: center;
  padding-bottom: 20px;
  display: flex;
`;

export const DateDiv = styled.div`
  right: 0;
  margin-left: 15px;
`;

export const SubmitDate = styled.button`
  height: 30px;
  border-radius: 8px;
  padding: 5px;
  padding-left: 10px;
  padding-right: 10px;
  color: white;
  align-self: center;
  margin-right: 15px;
  border: none;
  background: #17a2b8;
  margin-left: 10px;

  :hover {
    filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.2));
    border: solid grey 1px;
  }
`;

export const SelectDateButton = styled.button`
  height: 40px;
  border-radius: 20px;
  padding: 10px;
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 20px;
  color: white;
  align-self: center;
  margin-right: 15px;
  border: none;
  background: #17a2b8;
  margin-left: 10px;

  :hover {
    filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.2));
    border: solid grey 1px;
  }

  :selected {
    border: none;
  }
`;
